import { lazy, useMemo } from 'react';
import { Trans } from 'react-i18next';

const Button = lazy(() => import('core/generic/elements/button'));

type RichTextProps = {
	/**
	 * Already-translated copy containing a single `<0>...</0>` placeholder for
	 * the inline link.
	 */
	text: string;
	linkClassName?: string;
	dimension?: 'small' | 'medium' | 'large';
	href?: string;
};

/**
 * Renders translated copy with one inline link button.
 *
 * The `components` array is memoised: passing an array literal to `<Trans>`
 * re-created the element on every render at each of the nine call sites that
 * previously inlined this.
 */
export const RichText = ({
	text,
	linkClassName,
	dimension = 'medium',
	href,
}: RichTextProps) => {
	const components = useMemo(
		() => [
			<Button
				key="0"
				variant="link"
				dimension={dimension}
				className={linkClassName}
				href={href}
			/>,
		],
		[dimension, linkClassName, href]
	);

	return <Trans i18nKey={text} components={components} />;
};

export default RichText;
